import React                         from 'react';
import PropTypes                     from 'prop-types';
import SocialShareBarShareContentUrl from './SocialShareBarShareContentUrl';
import {gtagHelper, gaHelper}         from './../../utils/CommonUtils';
import EnumGA4Events                 from "../../utils/EnumGA4Events";
import './../../../../src/VX/Asset/Less/VX/View/social-share-bar.less';

// THESE HAVE TO BE EQUAL TO THE CONSTANTS IN EnumSocialShareBarOptions.php
const FACEBOOK_SHARE_BUTTON = 'facebook';
const TWITTER_SHARE_BUTTON  = 'twitter';
const TUMBLR_SHARE_BUTTON   = 'tumblr';
const BLOGGER_SHARE_BUTTON  = 'blogger';
const REDDIT_SHARE_BUTTON   = 'reddit';

// Image source for buttons
const FACEBOOK_SHARE_BUTTON_IMG = '/assets/icons/F_icon.svg';
const TWITTER_SHARE_BUTTON_IMG  = '/assets/icons/Twitter_bird_logo_2012.svg';
const BLOGGER_SHARE_BUTTON_IMG  = '/assets/icons/blogger-logo.svg';
const REDDIT_SHARE_BUTTON_IMG   = '/assets/icons/Reddit.svg';
const TUMBLR_SHARE_BUTTON_IMG   = '/assets/icons/tumblr-logo-white.svg';

// Hashtags used in shared Twitter-Message
const TWITTER_HASHTAGS = 'visitx,visitxtv,visitxstuff,visitxgirls,visitxbabes';

class SocialShareBarShareContent extends React.PureComponent {

	constructor(props) {
		super(props);

		this.onClickShareButton = this.onClickShareButton.bind(this);
	}

	generateFacebookShareUrl() {
		return `https://www.facebook.com/sharer/sharer.php?u=${encodeURI(this.props.url)}`;
	}

	generateTwitterShareUrl() {
		return `https://twitter.com/intent/tweet?&url=${encodeURI(this.props.url)}&hashtags=${TWITTER_HASHTAGS}`;
	}

	generateTumblrShareUrl() {
		return `http://tumblr.com/widgets/share/tool?canonicalUrl=${encodeURI(this.props.url)}`;
	}

	generateBloggerShareUrl() {
		return `https://blogger.com/blog-this.g?n=${this.props.title}&u=${encodeURI(this.props.url)}`;
	}

	generateRedditShareUrl() {
		return `https://www.reddit.com/submit?url=${encodeURI(this.props.url)}&title=${this.props.title}`;
	}

	onClickShareButton(event) {
		const gaTitle = this.props.gaPrefix + ':' + this.props.mediaId;

		gaHelper('send', 'event', 'SocialShareBar', event.target.title, gaTitle);
		gtagHelper(EnumGA4Events.DEFAULT_PARAMETER_EVENT, EnumGA4Events.DEFAULT_EVENT_SHARE, {
			[EnumGA4Events.DEFAULT_PARAMETER_METHOD]: event.target.title,
			[EnumGA4Events.DEFAULT_PARAMETER_ITEM_ID]: gaTitle,
		});
	}

	// Define Content of Share-Tab
	render() {

		// Define buttons if enabled
		const enabledButtons = this.props.shownShareButtons;
		const shareButtons   = [];
		const {
			      copyLinkTooltipChanged,
			      cssModifier,
			      isSeekableMedia,
			      showCopyLinkButton,
			      forceHideTooltip,
			      url,
		      }              = this.props;

		if (enabledButtons[FACEBOOK_SHARE_BUTTON] === true) {
			const facebookShareButton = (
				<a
				   key="social-share-bar__link-facebook"
				   className={'social-share-bar__link ' + cssModifier}
				   title="Facebook"
				   onClick={this.onClickShareButton}
				   href={this.generateFacebookShareUrl()}
				   target='_blank'
				>
					<span className={'social-share-bar__span facebook ' + cssModifier}>
						<img title="Facebook" className="social-share-bar__img facebook" src={FACEBOOK_SHARE_BUTTON_IMG} />
					</span>
				</a>);
			shareButtons.push(facebookShareButton);
		}

		if (enabledButtons[TWITTER_SHARE_BUTTON] === true) {
			const twitterShareButton = (
				<a
				   key="social-share-bar__link-twitter"
				   className={'social-share-bar__link -twitter ' + cssModifier}
				   title="Twitter"
				   onClick={this.onClickShareButton}
				   href={this.generateTwitterShareUrl()}
				   target="_blank"
				>
					<span className={'social-share-bar__span twitter ' + cssModifier}>
						<img title="Twitter" className="social-share-bar__img twitter" src={TWITTER_SHARE_BUTTON_IMG} />
					</span>
				</a>
			);
			shareButtons.push(twitterShareButton);
		}

		if (enabledButtons[TUMBLR_SHARE_BUTTON] === true) {
			const tumblrShareButton = (
				<a
				   key="social-share-bar__link-tumblr"
				   className={'social-share-bar__link ' + cssModifier}
				   title="Tumblr"
				   onClick={this.onClickShareButton}
				   href={this.generateTumblrShareUrl()}
				   target="_blank"
				>
					<span className={'social-share-bar__span tumblr ' + cssModifier}>
						<img title="Tumblr" className="social-share-bar__img tumblr" src={TUMBLR_SHARE_BUTTON_IMG} />
					</span>
				</a>
			);
			shareButtons.push(tumblrShareButton);
		}

		if (enabledButtons[BLOGGER_SHARE_BUTTON] === true) {
			const bloggerShareButton = (
				<a
				   key="social-share-bar__link-blogger"
				   className={'social-share-bar__link ' + cssModifier}
				   title="Blogger"
				   onClick={this.onClickShareButton}
				   href={this.generateBloggerShareUrl()}
				   target="_blank"
				>
					<span className={'social-share-bar__span blogger ' + cssModifier}>
						<img title="Blogger" className="social-share-bar__img blogger" src={BLOGGER_SHARE_BUTTON_IMG} />
					</span>
				</a>
			);
			shareButtons.push(bloggerShareButton);
		}

		if (enabledButtons[REDDIT_SHARE_BUTTON] === true) {
			const redditShareButton = (
				<a
				   key="social-share-bar__link-reddit"
				   className={'social-share-bar__link ' + cssModifier}
				   title="Reddit"
				   onClick={this.onClickShareButton}
				   href={this.generateRedditShareUrl()}
				   target="_blank"
				>
					<span className={'social-share-bar__span reddit ' + cssModifier}>
						<img title="Reddit" className="social-share-bar__img reddit" src={REDDIT_SHARE_BUTTON_IMG} />
					</span>
				</a>
			);
			shareButtons.push(redditShareButton);
		}

		return (
			<div id="socialShare" className={'social-share-bar__tabcontent ' + cssModifier}>
				{shareButtons}
				<SocialShareBarShareContentUrl videoUrl={url}
				                               isSeekableMedia={isSeekableMedia}
				                               cssModifier={cssModifier}
				                               showCopyLinkButton={showCopyLinkButton}
				                               copyLinkTooltipChanged={copyLinkTooltipChanged}
				                               forceHideTooltip={forceHideTooltip}
				/>
			</div>
		);
	}

}

SocialShareBarShareContent.propTypes = {
	url:                    PropTypes.string,
	title:                  PropTypes.string,
	mediaId:                PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	gaPrefix:               PropTypes.string,
	isSeekableMedia:        PropTypes.bool,
	shownShareButtons:      PropTypes.shape({
		blogger:  PropTypes.bool,
		facebook: PropTypes.bool,
		reddit:   PropTypes.bool,
		tumblr:   PropTypes.bool,
		twitter:  PropTypes.bool,
	}),
	cssModifier:            PropTypes.string,
	showCopyLinkButton:     PropTypes.bool,
	forceHideTooltip:       PropTypes.bool,
	copyLinkTooltipChanged: PropTypes.func,
};

SocialShareBarShareContent.defaultProps = {
	title:                  '',
	isSeekableMedia:        true,
	shownShareButtons:      {
		blogger:  true,
		facebook: true,
		reddit:   true,
		tumblr:   true,
		twitter:  true,
	},
	cssModifier:            '',
	showCopyLinkButton:     false,
	forceHideTooltip:       false,
	copyLinkTooltipChanged: () => {
	},
};

export default SocialShareBarShareContent;
